if (typeof FeaturedFrostedCards === 'undefined') {
    class FeaturedFrostedCards extends HTMLElement {
        connectedCallback() {
            const swiperEl = this.querySelector('.swiper');
            if (!swiperEl || this.swiper) return;

            whenReady('Swiper', () => {
                try {
                    this.swiper = new Swiper(swiperEl, {
                        loop: true,
                        a11y: true,
                        spaceBetween: 16,
                        slidesPerView: 1,
                        mousewheel: { forceToAxis: true, thresholdDelta: 12 },
                        autoHeight: true,
                        allowTouchMove: true,
                        pagination: {
                            el: this.querySelector('.swiper-pagination'),
                            clickable: true
                        },
                        breakpoints: {
                            768: {
                                enabled: false,
                                loop: false,
                                allowTouchMove: false,
                                mousewheel: false,
                                autoHeight: false
                            },
                        },
                        modules: [Swiper.A11y, Swiper.Pagination, Swiper.Mousewheel]
                    });

                    this.clearDesktopHeight = () => {
                        if (!this.swiper || !window.matchMedia('(min-width: 768px)').matches) return;
                        const wrapper = this.swiper.wrapperEl;
                        if (wrapper) wrapper.style.height = '';
                    };

                    this.swiper.on('breakpoint', this.clearDesktopHeight);
                    this.swiper.on('resize', this.clearDesktopHeight);
                    this.clearDesktopHeight();
                } catch (error) {
                    console.error('FeaturedFrostedCards: Failed to initialize Swiper:', error);
                }
            });
        }

        disconnectedCallback() {
            if (this.swiper) {
                if (this.clearDesktopHeight) {
                    this.swiper.off('breakpoint', this.clearDesktopHeight);
                    this.swiper.off('resize', this.clearDesktopHeight);
                }
                this.swiper.destroy(true, true);
                this.swiper = null;
            }
        }
    }

    if (!window.customElements.get('featured-frosted-cards')) {
        window.customElements.define('featured-frosted-cards', FeaturedFrostedCards);
    }
}
